"use strict";
const possibleNonCalculatedAlertIcon = (fromAdjustmentPriceSheet, ignoreAdjustmentLineItems, isMany) => {
  if (ignoreAdjustmentLineItems && fromAdjustmentPriceSheet) {
    return /* @__PURE__ */ React.createElement("span", { className: "load-detail__adjustments-icon" }, /* @__PURE__ */ React.createElement("i", { className: "fi-alert" }, nonCalculatedAlertMessage(isMany)));
  }
};
const nonCalculatedAlertMessage = (isMany) => {
  let message = "This item was imported as an adjustment and is not included\nin payment or expected amount calculations.";
  if (isMany) {
    message = "Some items were imported as adjustments and are not included\nin payment or expected amount calculations.";
  }
  return /* @__PURE__ */ React.createElement("span", { className: "load-detail__adjustments-message" }, message);
};
export default possibleNonCalculatedAlertIcon;
